@if (visible$ | async) {
  <div class="legend-list">
    @for (legendInfo of layers$ | async; track trackById($index, legendInfo)) {
      <tm-legend-layer [legendInfo]="legendInfo"></tm-legend-layer>
    }
  </div>
}
